import React, { useState } from "react";
import { sendEmail } from "../services/emailService";
import "./Formulario.css";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";

const PesquisaAulaExperimental = () => {
  const [respostas, setRespostas] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState(-1);

  const perguntas = [
    { label: "Qual sua faixa etária?", name: "faixa_etaria", options: ["Menos de 20 anos", "20 a 30 anos", "31 a 40 anos", "41 a 50 anos", "Acima de 50 anos"] },
    { label: "Qual seu gênero?", name: "genero", options: ["Feminino", "Masculino", "Prefiro não dizer"] },
    { label: "Qual seu principal objetivo ao procurar o Pilates?", name: "objetivo", options: ["Alívio de dores", "Reabilitação de lesões", "Melhora do condicionamento físico", "Bem-estar e relaxamento", "Outros"] },
    { label: "Você já praticou Pilates antes?", name: "praticou_pilates", options: ["Sim, regularmente", "Sim, mas por pouco tempo", "Não, esta foi minha primeira experiência"] },
    { label: "Qual sua ocupação principal?", name: "ocupacao", options: ["Profissional da saúde", "Trabalho administrativo/escritório", "Autônomo/Empreendedor", "Aposentado", "Outros"] },
    { label: "Como você conheceu nosso studio?", name: "como_conheceu", options: ["Indicação de amigos/familiares", "Redes sociais", "Anúncio online", "Pesquisa no Google", "Outros"] },
    { label: "Como você avalia sua experiência geral na aula experimental?", name: "avaliacao_geral", options: ["Excelente", "Boa", "Regular", "Ruim", "Muito ruim"] },
    { label: "Como foi o atendimento que você recebeu pelo WhatsApp antes da aula?", name: "atendimento_whatsapp", options: ["Excelente", "Bom", "Regular", "Ruim", "Muito ruim"] },
    { label: "Como foi o atendimento presencial ao chegar no studio?", name: "atendimento_presencial", options: ["Excelente", "Bom", "Regular", "Ruim", "Muito ruim"] },
    { label: "O que achou do ambiente do studio?", name: "ambiente", options: ["Muito agradável", "Agradável", "Regular", "Pouco agradável", "Desagradável"] },
    { label: "O que mais gostou na sua experiência na aula experimental?", name: "mais_gostou", type: "textarea" },
    { label: "Houve algo que não atendeu suas expectativas? Se sim, o que foi?", name: "expectativas", type: "textarea" },
    { label: "Você tem alguma sugestão para que se sinta mais confortável durante a aula?", name: "sugestoes", type: "textarea" },
    { label: "Em uma escala de 0 a 10, qual a probabilidade de você recomendar nossos serviços para familiares ou amigos?", name: "recomendacao", type: "scale" }
  ];

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setRespostas((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? [...(prev[name] || []), value] : value,
    }));
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 0) {
      setStep(step - 1);
    } else {
      setStep(-1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formattedRespostas = Object.entries(respostas)
        .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
        .join("\n");
        await sendEmail({ message: formattedRespostas }, "Aula exp. matriculado");
      setModalOpen(true);
    } catch (error) {
      alert("Erro ao enviar pesquisa.");
    }
  };

  return (
    <div className="page-container">
      <div className="header">
        <img src={logo} alt="Studio Corpo e Alma" className="logo logo-large" />
        <h2 className="header-title">Pesquisa de Satisfação<br />Aula Experimental</h2>
      </div>
      <div className="form-container">
        {step === -1 ? (
          <div className="intro-container">
            <h3 className="intro-text">Olá! Agradecemos por participar da nossa aula experimental no nosso Studio de Pilates. Sua opinião é muito importante para que possamos melhorar cada vez mais a sua experiência aqui dentro do Studio. Responda às perguntas abaixo com sinceridade:</h3>
            <hr />
            <button className="submit-button green-button" onClick={nextStep} style={{ width: '100%'}}>Responder Pesquisa</button>
          </div>
        ) : (
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 1.0 }}
          >
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label><strong>{perguntas[step].label}</strong></label>
                {perguntas[step]?.type === "scale" ? (
                  <div className="scale-group">
                    {[...Array(11)].map((_, i) => (
                      <button key={i} type="button" className="scale-button" style={{ backgroundColor: `rgb(${255 - i * 25}, ${i * 25}, 0)` }} onClick={() => setRespostas({ ...respostas, recomendacao: i })}>{i}</button>
                    ))}
                  </div>
                ) : perguntas[step].type === "textarea" ? (
                  <textarea name={perguntas[step].name} onChange={handleChange} className="textarea" value={respostas[perguntas[step].name] || ""} />
                ) : (
                  <div className="radio-group">
                    {perguntas[step].options.map((option, i) => (
                      <label key={i} className="radio-label">
                        <input type="radio" name={perguntas[step].name} value={option} checked={respostas[perguntas[step].name] === option} onChange={handleChange} />
                        {option}
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <hr />
                <div className="button-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  {step > 0 ? (
                    <button type="button" className="submit-button gray-button" onClick={prevStep}>
                      Voltar
                    </button>
                  ) : (
                    <div></div> // Espaço vazio para manter alinhamento quando o botão "Voltar" não aparece
                  )}
                  <button type={step < perguntas.length - 1 ? "button" : "submit"} className="submit-button green-button" onClick={step < perguntas.length - 1 ? nextStep : undefined}>
                    {step < perguntas.length - 1 ? "Próxima" : "Enviar Pesquisa"}
                  </button>
                </div>
            </form>
            {modalOpen && (
              <div className="modal">
                <div className="modal-content">
                  <p>Agradecemos por compartilhar sua opinião! Sua resposta nos ajuda a oferecer a melhor experiência possível. Esperamos vê-lo em breve no Studio! 😊</p>
                  <button onClick={() => setModalOpen(false)} className="close-button">Fechar</button>
                </div>
              </div>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default PesquisaAulaExperimental;